<template>
  <div class="eqc">
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4077673;201;pixel;Forbes;PSGCDDSFLATRNNETNTVForbesForbesForbesmicrositemltnative/?cachebuster='+timecurr()"
    />
    <div class="container">
      <h1 class="name">Mercedes EQC</h1>
      <h2 class="subtitle">A modellről</h2>
      <div class="interju">interjú</div>
    </div>
    <div class="whtbg">
      <div class="container block">
        <div class="personpicbox">
          <img
            class="personpic"
            src="../assets/img/mercedes-eqc-4-top.jpg"
            alt="Mercedes EQC"
          />
          <img
            class="bluebox"
            src="../assets/img/blue-box.svg"
          />
        </div>
        <div class="coloredtitle">
          Miért fontos az, hogy a Mercedes-Benz gyártson egy ilyen autót?
        </div>
        <p>A Mercedes-Benz kínálatában nem ez az első elektromos modell,
          hiszen volt a B-osztályból és a smart-ból is Electric Drive kiadás,
          amely 2007-ben jelent meg, így ez a hajtásrendszer nem idegen a
          márka történetében. Az EQ brand viszont teljesen új, ezzel a névvel
          kívánunk belépni és megújítani az elektromos meghajtású járművek piacát.
          A fenntarthatóság és a környezettudatosság a Mercedes-Benz számára mindig
          is kiemelt fontosságú volt, éppen ezért a folyamatos fejlesztések, kutatások
          és innovációk eredményeképpen jött létre az EQ brand, amely a Daimler
          jövőbeli mobilizációjának megtestesítője.</p>
        <div class="coloredtitle anim bottom">
          Ha Mercedes-Benz akkor luxus. Ebben az autóban mi az innováció,
          ami másnál nincs?</div>
        <p class="anim bottom">
          Minden olyan jellemzővel rendelkezik az EQC, amitől igazi Mercedes-Benzzé
          vált és amivel egyben kiemelkedik a többi elektromos modell közül. A hangtalanság és
          a nyugalom új szintjére emeli az autózás és az utazás élményét, amely azt eredményezi,
          hogy a járművezető ugyanolyan csendben tud haladni városban, mint főúton vagy autópályán.
          A luxus és a prémium életérzés ezáltal garantált, hiszen csendben, kényelmesen, de akár
          lehengerlően dinamikusan is használható az EQC, amely a hosszabb utakon is kiváló útitárs.
          Amennyiben lehetőségük nyílik, javaslom, hogy térjenek be a legközelebbi Mercedes-Benz EQ
          márkakereskedésbe és próbálják ki az autót, biztosan állítom, óriási élmény lesz.</p>
        <div class="clear"></div>
        <div class="anim bottom">
          <div class="coloredtitle">A hosszú út pont kérdéses az elektromos autóknál.</div>
          <p>Az EQC, használattól függően, akár 400 km-es hatótávra is képes, amely az
            emberek túlnyomó többségének a napi/heti utazási igényét lefedi. Az autót
            vezetve a járművezető mentalitása megváltozik, sokkal inkább nyugodtabb és
            kiegyensúlyozottabb vezetői stílust vesz fel, hiszen ez illeszkedik a legjobban
            az EQC szellemiségéhez. A töltés mindig egy sarkalatos pont az elektromos autóknál,
            de reálisan belegondolva ezzel a hatótávval nagyjából 4-5 óránként szükséges
            megállni legfeljebb 1 órára, amely így már kevésbé tűnik soknak. Egy ebéd vagy
            kávészünet alatt elegendő töltöttséget lehet szerezni a tovább haladáshoz.
            Más aspektusból vizsgálva, olyan töltőt is lehet találni, amely frekventált helyen van,
            így a töltés ideje alatt lehetőség nyílik akár bevásárolni vagy egy városrészt
            felfedezni, hogy a töltés élménnyé váljon.<br>
            Ezt segíti a Mercedes me nevű applikációnk, ami minden személyautóhoz elérhető,
            így az EQC-hoz is, de kibővített kényelmi funkciókkal. Az alkalmazásba beépített
            térképen láthatóak a töltőállomások egy része, amelyekhez a navigációt a telefonról
            el lehet küldeni a gépkocsi fedélzeti rendszerének, így már az utazásunk megkezdésekor
            láthatóak az utasítások. Ide sorolható az előklimatizálás funkció is, amelyet távolról,
            a mobiltelefonról lehet vezérelni és a megfelelő hőmérsékletet lehet beállítani
            az autó utasterében.</p>
        </div>
      </div>
      <div class="galleryblock">
        <img
          src="../assets/img/mercedes-eqc-page-gal-1.jpg"
          alt="Mercedes EQC"
        />
        <img
          src="../assets/img/mercedes-eqc-page-gal-2.jpg"
          alt="Mercedes EQC interior"
        />
        <img
          src="../assets/img/mercedes-eqc-page-gal-3.jpg"
          alt="Mercedes EQC"
        />
      </div>
      <div class="container block cols">
        <div class="colin">
          <div class="coloredtitle">Tehát a rendszer meg tudja mutatni nekem nem csak azt,
            hogyan jutok el A-ból B-be, hanem azt is, hogyan ejthetek
            útba egy töltőállomást például?</div>
          <p>Így van. Plusz az akkumulátorban elhelyezett hűtési és fűtési rendszer optimális
            hőmérsékletre temperálja az akkumulátorcsomagot mire a célhoz ér az autó,
            annak érdekében, hogy elérhető legyen a maximális töltési teljesítmény.</p>
          <div class="anim bottom">
            <div class="coloredtitle">Mennyi idő a töltés?</div>
            <p>Ez erősen függ a töltőállomás típusától. Az utcán elhelyezett publikus töltők
              nagyrésze lassúnak számít, ezeknél 10-11 órát vesz igénybe a töltés. Találhatunk
              ezektől gyorsabb villámtöltőket is, amelyekkel 3-4 óra, vagy akár 40 perc alatt
              is feltölthető az autó 80%-ra. A publikus töltőket leginkább hosszabb út esetén
              tovább haladáshoz vagy ún. kikapcsolódási célnál érdemes igénybe venni,
              a teljes feltöltést alapvetően otthon szükséges elvégezni este/éjszaka,
              ilyenkor idő is több van rá, illetve a költségvonzata is kedvezőbb, mint
              az utcai, fizetős töltőknél. </p>
          </div>
        </div>
        <div class="colin">
          <div class="coloredtitle">A töltőállomások bekalkulálása elég fontos innováció.
            Van még ehhez hasonló az autóban?</div>
          <p>Igen, az MBUX rendszer. Ez egy nagyon innovatív és intuitív infotainment
            rendszer az autóban, amely a kormány mögött elhelyezett kijelző rendszert,
            touchpadot, érintésérzékeny gombokat és hangvezérlést foglalja magában.
            A két 10,25”-os kijelzőn megjelenő tartalom teljesen egészében
            személyre szabható, így nincs két egyforma beállítás. A navigációs térkép,
            a multimédiás rendszer illetve az utazási adatok megjelenítése mellett
            az EQ specifikus beállítások és funkciók is innen érhetőek el.
            Természetesen az okostelefonnal is összekapcsolható a fedélzeti rendszer
            Bluetooth-on illetve Android Auto vagy Apple CarPlay-en keresztül.</p>
          <div class="anim bottom">
            <div class="coloredtitle">Kiterjesztett valóságot használ az autó?</div>
            <p>Igen, ez a funkció is kérhető az autóba. Ezt úgy kell elképzelni,
              hogy a navigáció célhoz vezetéskor segítségül hív egy kameraképet is,
              amelynek a lencséje az autóban található. Amikor utasítás történik,
              nem csak a térképen mutatja dinamikusan a forgalmi szituációt,
              hanem a média kijelzőre a kamera képét is kivetíti és ráhelyezi az utasítás irányát.
              Ez forgalmas és sűrű városrészek esetén nagyon megkönnyíti a közlekedést.</p>
          </div>
        </div>
      </div>
      <div class="container block mid">
        <div class="personpicbox">
          <img
            class="personpic"
            src="../assets/img/mercedes-eqc-5-bottom.jpg"
            alt="Mercedes EQC"
          />
          <img
            class="bluebox"
            src="../assets/img/blue-box.svg"
          />
        </div>
        <div class="coloredtitle anim bottom">Azt olvastam, hogy van egy olyan üzemmód,
          ami a hatékonyságot növeli.</div>
        <p class="anim bottom">Két olyan fejlesztés van az EQC-ben, ami a többi típusban nem
          vagy csak részben elérhető. Egyrészt van négy menetmód az autóban,
          és ezen felül egy Maximum Range fokozat, amit külön EQC-hez
          fejlesztettünk. Ebben a módban az autó a maximális hatékonyságra
          törekszik úgy, hogy a járművezetőnek aktív és passzív tanácsokat ad.
          Passzívak esetén az ECO Asszisztens figyelmezteti a vezetőt, a radarok,
          kamerák és szenzorok alapján, a várható forgalmi szituációkról.
          Így pl. nagyobb forgalom esetén finoman, vizuálisan jelzi, hogy
          vegye le a lábát a menetpedálról, mert hamarosan meg kell állni,
          ezért felesleges energiát használni. Illetve ebben a menetmódban
          is aktiválódik a haptikus menetpedál, ami azt jelenti, hogy az EQC
          automatikusan szabályozza a menetpedál nyomáspontját, a radarok és a
          kamerák alapján. Ez a gyakorlatban azt jelenti, hogy forgalmasabb közlekedési
          körülmények között ugyanolyan menetpedál állásnál csak kevesebb energiát
          enged az autó használni, mint más módban. Hétköznapi használat során ez a
          funkció kiválóan alkalmas arra, hogy hatékonyan és takarékosan tudjunk
          eljutni a célunkhoz.<br>
          Az EQC másik specifikus funkciója a kormány mögött elhelyezett gombok,
          amelyekkel az energia visszatöltés fokozatait lehet szabályozni.
        </p>
        <div class="clear"></div>
      </div>
      <div class="container block last">
        <div class="anim bottom">
          <div class="coloredtitle">
            A tesztek szerint nagyon érdekes a fékrendszere az autónak.</div>
          <p>Az EQC lassítás során kétféle féket használhat.
            Egyrészt az üzemi féket, amely minden autóban megtalálható, és a féktárcsa,
            fékbetét alkotja, a másik pedig az elektromos motor fizikai jellemzőinek
            köszönhetően a rekuperációs fékezést. Utóbbi esetében a mozgási energia fékezés
            során elektromos energiává alakul, amely energia az autó akkumulátorába
            kerül vissza, ezzel is növelve a hatékonyságot. A fékpedál lenyomása során,
            egy bizonyos mértékig, az EQC a rekuperatív fékezéssel lassít, majd utána veszi
            igénybe az üzemi féket. Ezzel egyrészt energiát takarít meg, másrészt az üzemi
            fék elemeit kíméli, amelyek így sokkal tartósabbak, mint a hagyományos meghajtású
            járműveknél. Az átmenet a két mód között észrevehetetlen.</p>
        </div>
        <div class="anim bottom">
          <div class="coloredtitle">Mindenkinek való ez az autó?</div>
          <p>Aki napi szinten 5-600 kilométert megy, reggeltől estig, annak jelenleg még
            nem jelent alternatívát az elektromos autózás. Azonban mindenki másnak bátran
            ajánlom és javaslom, hogy hosszabb távon próbálja ki az autót, mert valóban rá
            tud világítani arra, hogy a töltés és a hatótáv már nem sarokpont, amely jelenleg
            még gyakran ellenérv szokott lenni az elektromos autóknál. Amikor a szkeptikus
            véleményeket hallom, mindig azt válaszolom, hogy mindenki gondolja végig az utazási
            szokásait, hiszen egy elektromos autó remekül hozzáilleszthető gyakorlatilag
            bármilyen élethelyzethez. Hány km-t megy egy év alatt, milyen megoszlásban,
            ha hosszabb útra megy, milyen gyakran áll meg és mennyi időre.</p>
        </div>
        <div class="anim bottom">
          <div class="coloredtitle">A német autóklub tanulmánya szerint, ha a német energiamixet
            nézzük, akkor 130 ezer megtett kilométer után tud teljesen környezettudatos
            lenni a vásárló.</div>
          <p>Hasonló értékkel kalkulálunk mi is, de ahogy a technológia fejlődik ez a szám
            egyre nagyobb mértékben lesz kisebb. Nem szabad elfelejteni azt, hogy a lokális
            szennyezés gyakorlatilag 0 és azt sem, hogy az elektromos autókban használt energia
            megújuló energiaforrásból is származhat, amely teljesen más városképeket tudna
            kialakítani. Egy elektromos autó esetében nem egy- két évre kell előre gondolkodni,
            hanem jóval hosszabb időre, hiszen ez egy befektetés, amelyet a jövőnkért teszünk.
            Mi lesz a városokból 8-10 év múlva, ha minden ugyanígy halad tovább?</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'eqc',
  components: {},
  data() {
    return {};
  },
  methods: {
    animateBoxes() {
      const picbox = document.querySelectorAll('.personpicbox');
      window.addEventListener(
        'scroll',
        () => {
          for (let index = 0; index < picbox.length; index += 1) {
            const element = picbox[index];
            this.moveCalculator(element);
          }
        },
        { passive: true },
      );
      window.addEventListener('touchmove', () => {
        for (let index = 0; index < picbox.length; index += 1) {
          const element = picbox[index];
          this.moveCalculator(element);
        }
      });
    },
    moveCalculator(element) {
      const itemCenter = element.offsetTop + element.offsetHeight / 2;
      const scrollStart = window.pageYOffset + window.innerHeight / 10;
      const scrollEnd = window.pageYOffset + (window.innerHeight / 10) * 9;
      const scrollMid = scrollStart + (scrollEnd - scrollStart) / 2;
      const scrollRange = itemCenter - scrollMid;
      const distance = 0.15;

      if (itemCenter <= scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
      if (itemCenter > scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
    },
    isinviewElement(array) {
      for (let index = 0; index < array.length; index += 1) {
        const element = array[index];
        if (element.getBoundingClientRect().top < window.innerHeight
          && element.getBoundingClientRect().bottom > 0) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      }
    },
    isinviewScroll() {
      const anim = document.querySelectorAll('.anim');
      window.addEventListener('scroll', () => {
        this.isinviewElement(anim);
      }, { passive: true });
      window.addEventListener('touchmove', () => {
        this.isinviewElement(anim);
      });
      window.addEventListener('Load', () => {
        this.isinviewElement(anim);
      });
    },
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
    this.animateBoxes();
    this.isinviewScroll();
  },
};
</script>
<style scoped lang="css">
.eqc {
  padding-top: 60px;
}
.container.block {
  background-color: #fff;
  color: #151726;
  padding: 50px 60px;
  overflow: hidden;
}
.container.block.cols {
  padding: 50px 60px 0 60px;
}
.container.block.mid {
  padding: 0 60px 0 60px;
}
.container.block.last {
  padding: 0 60px 50px 60px;
}
.name {
  text-transform: uppercase;
  font-size: 18px;
  margin-block-start: 0;
  margin-block-end: 30px;
  font-weight: normal;
}
.subtitle {
  font-size: 77px;
  font-family: "Old Standard TT", serif;
  margin-block-start: 0;
  margin-block-end: 25px;
  font-weight: normal;
  line-height: 1;
}
.container {
  padding: 0 60px;
  width: calc(100% - 120px);
}
.interju {
  margin-bottom: 40px;
  color: #00adef;
  font-size: 18px;
}
.coloredtitle {
  color: #00adef;
  font-size: 21px;
  margin: 20px 0;
  line-height: 1.5;
}
.container p {
  font-size: 18px;
  line-height: 1.5;
}
.galleryblock {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-columns: 1fr 1fr 1fr;
}
.galleryblock img {
  width: 100%;
}
.galleryblock img:nth-child(1) {
  -ms-grid-column: 1;
}
.galleryblock img:nth-child(2) {
  -ms-grid-column: 2;
}
.galleryblock img:nth-child(3) {
  -ms-grid-column: 3;
}
.personpicbox {
  float: left;
  position: relative;
  overflow: hidden;
  display: -ms-flexbox;
}
.mid .personpicbox {
  float: right;
}
.bluebox,
.personpic {
  width: 350px;
}
.bluebox {
  margin: 0 120px 40px 40px;
  z-index: 1;
  position: relative;
}
.personpic {
  position: absolute;
  left: 120px;
  bottom: -20px;
  z-index: 2;
}
.mid .bluebox {
  margin: 0 0 40px 160px;
}
.mid .personpic {
  right: 80px;
  left: initial;
}
.mid .coloredtitle,
.mid p {
  text-align: right;
}
.clear {
  clear: both;
  margin-top: 20px;
}
.cols {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr;
  -ms-grid-columns: 1fr 1fr;
}
.colin:nth-child(1) {
  padding-right: 30px;
  grid-column: 1/2;
  -ms-grid-column: 1;
}
.colin:nth-child(2) {
  padding-left: 30px;
  grid-column: 2/3;
  -ms-grid-column: 2;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.anim {
  overflow: hidden;
}
.anim.left {
  transform: translateX(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.left.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.right {
  transform: translateX(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.right.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.top {
  transform: translateY(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.top.active {
  transform: translateY(0%);
  opacity: 1;
}
.anim.bottom {
  transform: translateY(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.bottom.active {
  transform: translateY(0%);
  opacity: 1;
}
.container.block.mid > p {
  display: inline;
}
@media screen and (max-width: 767px) {
  .eqc {
    padding-top: 30px;
  }
  .subtitle {
    font-size: 45px;
  }
  .container {
    padding: 0 30px;
    width: calc(100% - 60px);
  }
  .container.block {
    padding: 50px 30px;
  }
  .galleryblock {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .container.block.cols {
    padding: 50px 30px 0px 30px;
  }
  .container.block.mid {
    padding: 0 30px 0 30px;
  }
  .container.block.last {
    padding: 0 30px 50px 30px;
  }
  .cols {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .colin:nth-child(1) {
    padding-right: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .colin:nth-child(2) {
    padding-left: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .bluebox,
  .personpic {
    width: 250px;
  }
  .bluebox {
    margin: 0 80px 30px 0px;
  }
  .personpic {
    left: 45px;
    bottom: -10px;
  }
  .mid .bluebox {
    margin: 0 0 30px 80px;
  }
  .mid .personpic {
    right: 45px;
  }
  .anim.left,
  .anim.right {
    transform: translateX(0%);
    opacity: 1;
  }
  .anim.top,
  .anim.bottom {
    transform: translateY(0%);
    opacity: 1;
  }
}
@media screen and (max-width: 640px) {
  .bluebox,
  .personpic {
    width: 200px;
  }
  .personpic {
    left: 30px;
  }
  .mid .personpic {
    right: 30px;
  }
  .mid .bluebox {
    margin: 0 0 30px 55px;
  }
  .bluebox {
    margin: 0 55px 30px 0px;
  }
}
@media screen and (max-width: 540px) {
  .bluebox,
  .personpic {
    width: 160px;
  }
  .personpic {
    left: 20px;
  }
  .mid .personpic {
    right: 20px;
  }
  .mid .bluebox {
    margin: 0 0 30px 50px;
  }
  .bluebox {
    margin: 0 50px 30px 0px;
  }
  .coloredtitle {
    font-size: 19px;
  }
  .subtitle {
    font-size: 40px;
  }
  .mid .coloredtitle {
    min-width: 120px;
  }
}
</style>
